export const chargeType = {
  fixedAmount: 0,
  percentage: 1,
};
